import axios from './axiosService';

export default {
  deleteGroup(groupID) {
    return axios.delete(`/api/groups/${groupID}`)
      .then(response => response.data);
  }
}
